import { useMediaPlayerOptional } from '../contexts/MediaPlayerContext';
import './HeaderMediaControl.css';

export function HeaderMediaControl() {
  const mediaPlayer = useMediaPlayerOptional();

  // Don't render if no context or nothing playing
  if (!mediaPlayer || !mediaPlayer.currentMedia) {
    return null;
  }

  const { currentMedia, isPlaying, pause, play, stop } = mediaPlayer;

  const isBandcamp = currentMedia.type === 'bandcamp';

  const handleStop = () => {
    stop();
  };

  const handlePlayPause = () => {
    if (isPlaying) {
      pause();
    } else {
      play();
    }
  };

  // Truncate long titles
  const displayTitle = currentMedia.title.length > 30
    ? currentMedia.title.slice(0, 27) + '...'
    : currentMedia.title;

  return (
    <div className={`header-media-control ${isPlaying ? 'playing' : 'paused'}`}>
      <span className="media-icon">
        {currentMedia.type === 'youtube' ? (
          <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
            <path d="M0 18.75l7.437-13.5H24l-7.438 13.5H0z"/>
          </svg>
        )}
      </span>
      <span className="media-title">{displayTitle}</span>

      <div className="media-controls">
        {/* Bandcamp only gets stop - no play/pause */}
        {!isBandcamp && (
          <button
            className="control-btn play-pause"
            onClick={handlePlayPause}
            title={isPlaying ? 'Pause' : 'Play'}
          >
            {isPlaying ? (
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                <path d="M8 5v14l11-7z"/>
              </svg>
            )}
          </button>
        )}

        <button
          className="control-btn stop"
          onClick={handleStop}
          title="Stop"
        >
          <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
            <path d="M6 6h12v12H6z"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
